/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeVillageObservationDeleteResultDto,
  ApiEnvelopeVillageObservationListDto,
  ApiEnvelopeVillageObservationRunListDto,
  VillageObservationExportParams,
  VillageObservationGetMineParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type villageObservationGetMineResponse200 = {
  data: ApiEnvelopeVillageObservationListDto
  status: 200
}

export type villageObservationGetMineResponse401 = {
  data: ApiEnvelopeVillageObservationListDto
  status: 401
}

export type villageObservationGetMineResponseSuccess = (villageObservationGetMineResponse200) & {
  headers: Headers;
};
export type villageObservationGetMineResponseError = (villageObservationGetMineResponse401) & {
  headers: Headers;
};

export type villageObservationGetMineResponse = (villageObservationGetMineResponseSuccess | villageObservationGetMineResponseError)

export const getVillageObservationGetMineUrl = (params?: VillageObservationGetMineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/VillageObservation?${stringifiedParams}` : `/api/VillageObservation`
}

export const useVillageObservationGetMineHook = (): (params?: VillageObservationGetMineParams, options?: RequestInit) => Promise<villageObservationGetMineResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: VillageObservationGetMineParams, options?: RequestInit) => {

        return customFetcher(getVillageObservationGetMineUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type villageObservationDeleteAllMineResponse200 = {
  data: ApiEnvelopeVillageObservationDeleteResultDto
  status: 200
}

export type villageObservationDeleteAllMineResponse401 = {
  data: ApiEnvelopeVillageObservationDeleteResultDto
  status: 401
}

export type villageObservationDeleteAllMineResponseSuccess = (villageObservationDeleteAllMineResponse200) & {
  headers: Headers;
};
export type villageObservationDeleteAllMineResponseError = (villageObservationDeleteAllMineResponse401) & {
  headers: Headers;
};

export type villageObservationDeleteAllMineResponse = (villageObservationDeleteAllMineResponseSuccess | villageObservationDeleteAllMineResponseError)

export const getVillageObservationDeleteAllMineUrl = () => {




  return `/api/VillageObservation`
}

export const useVillageObservationDeleteAllMineHook = (): ( options?: RequestInit) => Promise<villageObservationDeleteAllMineResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVillageObservationDeleteAllMineUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type villageObservationGetRunsResponse200 = {
  data: ApiEnvelopeVillageObservationRunListDto
  status: 200
}

export type villageObservationGetRunsResponse401 = {
  data: ApiEnvelopeVillageObservationRunListDto
  status: 401
}

export type villageObservationGetRunsResponseSuccess = (villageObservationGetRunsResponse200) & {
  headers: Headers;
};
export type villageObservationGetRunsResponseError = (villageObservationGetRunsResponse401) & {
  headers: Headers;
};

export type villageObservationGetRunsResponse = (villageObservationGetRunsResponseSuccess | villageObservationGetRunsResponseError)

export const getVillageObservationGetRunsUrl = () => {




  return `/api/VillageObservation/runs`
}

export const useVillageObservationGetRunsHook = (): ( options?: RequestInit) => Promise<villageObservationGetRunsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getVillageObservationGetRunsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type villageObservationExportResponse200 = {
  data: Blob
  status: 200
}

export type villageObservationExportResponseSuccess = (villageObservationExportResponse200) & {
  headers: Headers;
};
;

export type villageObservationExportResponse = (villageObservationExportResponseSuccess)

export const getVillageObservationExportUrl = (params?: VillageObservationExportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/VillageObservation/export?${stringifiedParams}` : `/api/VillageObservation/export`
}

export const useVillageObservationExportHook = (): (params?: VillageObservationExportParams, options?: RequestInit) => Promise<villageObservationExportResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: VillageObservationExportParams, options?: RequestInit) => {

        return customFetcher(getVillageObservationExportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


